import { render } from "./Set-Public.vue?vue&type=template&id=0b6cfeef&scoped=true"
import script from "./Set-Public.vue?vue&type=script&lang=js"
export * from "./Set-Public.vue?vue&type=script&lang=js"

import "./Set-Public.vue?vue&type=style&index=0&id=0b6cfeef&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6cfeef"]])

export default __exports__